import styles from './Autocomplete.scss';
import cn from 'classnames';
import Highlighter from 'react-highlight-words';
import { RemoveButton } from 'app/components/tripLocation/Autocomplete/RemoveButton';
import React from 'react';
import { ResultsType as ResultsPropType } from 'app/hooks/useResults';
import { AutocompleteOptionType } from '@flixbus/honeycomb-react/src/components/autocomplete/autocomplete-options/types';
import { AutocompleteResult, AutocompleteResultStation } from 'app/models/types/store/location';
import { Icon, IconPin, IconTrain } from 'app/icons';
import { useTranslations } from 'app/hooks/useTranslations';
import { a11yLabelsKeys } from 'app/providers/a11yLabels';

type OptionPropTypes = {
  value: string;
  resultType: ResultsPropType;
  item: AutocompleteOptionType;
  citiesById: Record<
    string,
    AutocompleteResult & { positionOnList: number; station: AutocompleteResultStation }
  >;
  direction: 'from' | 'to';
};
export const Option = ({ value, resultType, item, citiesById, direction }: OptionPropTypes) => {
  const { getAllStopsLabel, getTrainStationLabel } = useTranslations({
    getAllStopsLabel: 'search_mask.label.all_stops',
    getTrainStationLabel: a11yLabelsKeys.trainStation,
  });

  if (item.key === 'map') {
    return null;
  }

  const cityData = item.key ? citiesById[item.key] : undefined;

  const isTrain = cityData?.station?.is_train;

  return (
    <>
      {cityData && (
        <div
          className={cn(styles.optionWrapper, {
            [styles.station]: cityData.isStation,
          })}
        >
          <div className={cn('notranslate', styles.option)}>
            <div className={styles.cityName}>
              {cityData.isStation && (
                <Icon
                  appearance="primary"
                  extraClasses={styles.pinIcon}
                  aria-hidden={!isTrain}
                  aria-label={isTrain ? getTrainStationLabel() : ''}
                  InlineIcon={isTrain ? IconTrain : IconPin}
                />
              )}
              <Highlighter searchWords={[value]} textToHighlight={item.title} autoEscape />
              {!!cityData.stations?.length &&
                cityData.stations?.length > 1 &&
                resultType === 'autocomplete' && <span> ({getAllStopsLabel()})</span>}
            </div>
            <div className={styles.additionalInfo}>{item.subtitle}</div>
          </div>
          {resultType === 'recent' && <RemoveButton city={cityData} direction={direction} />}
        </div>
      )}
    </>
  );
};
